import { render, staticRenderFns } from "./UserGroupInput.vue?vue&type=template&id=1164f70e&scoped=true"
import script from "./UserGroupInput.vue?vue&type=script&lang=ts"
export * from "./UserGroupInput.vue?vue&type=script&lang=ts"
import style0 from "./UserGroupInput.vue?vue&type=style&index=0&id=1164f70e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1164f70e",
  null
  
)

export default component.exports